/**
 * FIDDUX PDF Report Branding
 * Alinhado ao FIDDUX Branding Guideline
 * Cormorant Garamond + Helvetica Neue | Primary #2AF598 | Dark Grey #353535
 */

export const FIDDUX_BRANDING = {
  primary: '#353535',
  accent: '#2AF598',
  secondary: '#00BA2D',
  tertiary: '#009658',
  accentBlue: '#3A87DE',
  white: '#FFFFFF',
  black: '#000000',
  grey: '#AAAAAA',
  offWhite: '#C8C9CB',
  textPrimary: '#353535',
  textSecondary: '#718096',
  border: '#e8ecef',
  highlightBg: '#f0fdf7',
  fontHeader: '"Cormorant Garamond", "Georgia", serif',
  fontBody: '"Helvetica Neue", "Helvetica", sans-serif',
  fontData: '"Courier New", monospace',
  spacing: { xs: 4, sm: 8, md: 16, lg: 24, xl: 32 },
  radius: { sm: 8, md: 12, lg: 16 },
  logoUrl: 'https://firebasestorage.googleapis.com/v0/b/fidduxai-rowy.appspot.com/o/Pdf_Logo%2FFIDDUX.png?alt=media&token=711f5183-6336-406e-936a-b3ca2c4e3768',
};

export const getReportStyles = (branding = FIDDUX_BRANDING) => `
  <style>
    @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500&display=swap');
    * { box-sizing: border-box; }
    body { margin: 0; padding: 0; font-family: ${branding.fontBody}; font-size: 11pt; color: ${branding.textPrimary}; }
    .fiddux-pdf-root { width: 100%; max-width: 210mm; margin: 0 auto; display: flex; flex-direction: column; align-items: center; }
    .fiddux-pdf-root > * { max-width: 170mm; width: 100%; }
    .fiddux-cover { 
      height: 297mm;
      min-height: 297mm;
      max-height: 297mm;
      display: flex; 
      flex-direction: column; 
      align-items: center; 
      justify-content: center;
      padding: 16px 24px;
      background: ${branding.white};
      page-break-inside: avoid;
      overflow: hidden;
      box-sizing: border-box;
    }
    .fiddux-cover-block { display: flex; flex-direction: column; align-items: center; gap: 0; max-width: 140mm; }
    .fiddux-cover-logo { max-width: 64mm; max-height: 32mm; margin-bottom: 20px; }
    .fiddux-cover-logo-text { font-family: ${branding.fontHeader}; font-size: 28pt; font-weight: 600; font-style: italic; color: ${branding.primary}; letter-spacing: 0.12em; margin-bottom: 20px; }
    .fiddux-cover-title { font-family: ${branding.fontHeader}; font-size: 20pt; font-weight: 600; font-style: italic; color: ${branding.primary}; margin: 0; text-align: center; line-height: 1.4; width: 100%; }
    .fiddux-cover-details { display: flex; flex-direction: column; align-items: center; margin-top: 64px; max-width: 140mm; }
    .fiddux-cover-subtitle { font-size: 10pt; color: ${branding.textSecondary}; margin: 0 0 24px; letter-spacing: 0.04em; text-align: center; }
    .fiddux-cover-prepared { font-size: 9pt; color: ${branding.primary}; margin: 0 0 20px; font-weight: 600; text-align: center; }
    .fiddux-cover-partners { font-size: 8pt; color: ${branding.textSecondary}; margin: 0 0 28px; text-align: center; line-height: 1.5; }
    .fiddux-cover-date { font-size: 8pt; color: ${branding.textSecondary}; text-align: center; }
    .fiddux-page { padding: 24mm 20mm 0; margin: 0 auto; max-width: 170mm; width: 100%; }
    .fiddux-section { margin-bottom: 0; }
    .fiddux-section + .fiddux-section { margin-top: 0; }
    .fiddux-h1 { font-family: ${branding.fontHeader}; font-size: 18pt; font-weight: 600; font-style: italic; color: ${branding.primary}; margin: 0 0 20px; page-break-after: avoid; }
    .fiddux-h2 { font-family: ${branding.fontHeader}; font-size: 14pt; font-weight: 600; color: ${branding.primary}; margin: 28px 0 12px; page-break-after: avoid; }
    .fiddux-h3 { font-family: ${branding.fontHeader}; font-size: 12pt; font-weight: 500; color: ${branding.textPrimary}; margin: 24px 0 10px; page-break-after: avoid; }
    .fiddux-body { font-size: 10.5pt; line-height: 1.65; color: ${branding.textPrimary}; }
    .fiddux-body p { margin: 0 0 10px; }
    .fiddux-body strong { font-weight: 600; }
    .fiddux-body em { font-style: italic; }
    .fiddux-body code { font-family: ${branding.fontData}; font-size: 10pt; background: ${branding.secondary}; padding: 2px 6px; border-radius: 4px; }
    .fiddux-body a { color: ${branding.accentBlue || '#3A87DE'}; text-decoration: underline; }
    .fiddux-body ul, .fiddux-body ol { margin: 10px 0; padding-left: 24px; }
    .fiddux-table-wrapper { page-break-inside: avoid; break-inside: avoid; margin: 20px 0; }
    .fiddux-table { width: 100%; border-collapse: collapse; font-size: 9.5pt; table-layout: auto; }
    .fiddux-table th { background: ${branding.primary}; color: ${branding.white}; padding: 8px 10px; text-align: center; font-weight: 600; }
    .fiddux-table td { padding: 8px 10px; border: 1px solid ${branding.border}; text-align: center; vertical-align: middle; }
    .fiddux-table tr:nth-child(even):not(.fiddux-table-total) { background: ${branding.offWhite || '#f5f5f5'}; }
    .fiddux-table tr.highlight-row { background: ${branding.highlightBg} !important; }
    .fiddux-table tr.fiddux-table-total { background: ${branding.primary} !important; color: ${branding.white}; font-weight: 600; }
    .fiddux-table tr.fiddux-table-total td { border-color: ${branding.primary}; }
    .fiddux-highlight { border-left: 4px solid ${branding.accent}; background: ${branding.highlightBg}; padding: 14px 18px; margin: 18px 0; border-radius: 8px; }
    .fiddux-highlight-box { border-left: 4px solid ${branding.accent}; background: ${branding.highlightBg}; padding: 14px 18px; margin: 16px 0; border-radius: 8px; page-break-inside: avoid; }
    .fiddux-highlight-box .box-title { font-weight: 600; color: ${branding.primary}; margin-bottom: 6px; font-size: 11pt; }
    .fiddux-highlight-box .box-content { font-size: 10pt; line-height: 1.5; }
    .fiddux-chart-container { margin: 20px 0; width: 100%; height: 240px; position: relative; page-break-inside: avoid; }
    .fiddux-chart-container canvas { max-width: 100% !important; }
    .fiddux-chart-title { font-weight: 600; color: ${branding.primary}; margin-bottom: 8px; font-size: 11pt; }
    .fiddux-page-break { page-break-before: always; margin-top: 0; padding-top: 0; }
    .fiddux-footer-spacer { height: 26mm; min-height: 26mm; page-break-inside: avoid; }
    .fiddux-subsection-gap { margin-bottom: 20px; }
  </style>
`;
